export default "__VITE_ASSET__DIkLrsaB__"